import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../crud.service';

@Injectable({ providedIn: 'root' })
export class GatewayCategoryService extends CrudService {
  constructor(protected http: HttpClient) {
    super(http, 'gateway_categories');
  }
}
